'use client';
import { useEffect } from 'react';

export default function PushOwl() {
  useEffect(() => {
    // Trigger Opt-In Flow
    setTimeout(() => {
      if (window.pushowl) {
        window.pushowl.trigger('showWidget', {
          type: 'optinFlows',
        });
      }
    },5000);

    // Trigger only push notification permission prompt
    setTimeout(() => {
      window.pushowl.trigger('getCurrentPermission').then((permission: any) => {
        if (permission !== 'default') return;
        window.pushowl.trigger('showWidget', { 
          type: 'browserPrompt', 
        });
      });
    },5000);
  },[]);

  return (<></>);
}